import { Link } from 'react-router-dom'
import { offersLoadingBay } from '@/modules/packhouse/ColdroomToLoadingBay'

// U18 UF-02: one muted line under a pallet in the cell drawer: export or local,
// the truck it is planned on, and what happens next. Plain text, not a pill.
// Export by the same rule as the "To loading bay" button.
export function ColdroomRowCaption({ channel, targetMarket, missionNumber, canOpenDispatch }: {
  channel: string | null
  targetMarket: string | null
  /** From the loading_missions embed. Null when none, or when the read refused it. */
  missionNumber: string | null
  canOpenDispatch: boolean
}) {
  const isExport = offersLoadingBay({ channel, target_market: targetMarket })
  const kind = isExport ? (targetMarket ? `Export · ${targetMarket}` : 'Export') : 'Local'
  return (
    <p className="text-caption text-fg-muted truncate" data-testid="coldroom-row-caption">
      {kind}
      {missionNumber
        ? ` · On ${missionNumber}`
        : !isExport && (
          <>
            {' · leaves from '}
            {canOpenDispatch
              ? <Link to="/dispatch" className="underline">Dispatch</Link>
              : 'Dispatch'}
          </>
        )}
    </p>
  )
}
